import * as React from "react";

const ExpenseWarning: React.FC = () => {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="32" 
            height="32"
            viewBox="0 0 32 32"
        >
            <path d="M14 20a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM13 9h2v9h-2V9Z"/><path d="M27 27H1a1 1 0 0 1-.89-1.46l13-25a1 1 0 0 1 1.78 0l13 25A1 1 0 0 1 27 27ZM2.65 25h22.7L14 3.17 2.65 25Z"/>
        </svg>
    );
};

export default React.memo(ExpenseWarning);
